import Base from './Base';

class Payment extends Base {

    constructor (token) {
        super(token);
        this.endpoint = 'payments';
    }

   

    cancel ( data ) {
        return fetch(this.getUrlEndpoint("cancel"),{
            method: 'POST',
            headers: this.headers,
            body: JSON.stringify(data)
        }).then( response => response.json() )
    }
    
    capture ( data ) {
        return fetch(this.getUrlEndpoint("capture"),{
            method: 'POST',
            headers: this.headers,
            body: JSON.stringify(data)
        }).then( response => response.json() )
    }

}

export default Payment;